'use client'

import ErrorRecoveryCard from './components/error-recovery-card'
import './globals.css'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="en">
      <body className="m-0 min-h-screen bg-ocean font-sans antialiased">
        <div className="flex min-h-screen flex-col items-center justify-center px-4 py-12">
          <ErrorRecoveryCard error={error} reset={reset} />
        </div>
      </body>
    </html>
  )
}
